<template>
  <div class="row">
    <div id="contentTop" />

    <div v-if="error" class="col-md-12 card">
      <div class="card-header noprint">
        <h4 class="card-title">Oops!</h4>
      </div>
      <div class="card-content row">
        <p class="col-md-12">Something went wrong loading this verification request. Please try again or report this error.</p>
      </div>
    </div>
    <div v-else-if="notfound || (verifications && verifications.length < 1)" class="col-md-12 card">
      <div class="card-header noprint">
        <h4 class="card-title">Not Found</h4>
      </div>
      <div class="card-content row">
        <p class="col-md-12">This verification or wallet could not be found, or the owner has stopped sharing it with you.</p>
        <p class="col-md-12">Please close this window.</p>
      </div>
    </div>


    <!-- <div v-else class="col-md-12 card">
      <div class="card-header noprint">
        <h4 class="card-title">???.</h4>
        <div class="category">???.</div>
      </div>
      <div class="card-content row">
        <result 
          :result=verification.result 
          :notes="verification ? verification.notes : null" 
          :thirdPartyData="verification ? verification.fields['thirdPartyData'] : null"
          :verification="newVerification" /> 
      </div>
    </div> -->

    <wallet v-if="verifications && verifications.length >= 1" :initHistory="verifications" :public="true" />

  </div>
</template>

<script>
  import DynamicInput from 'src/views/Verifications/components/DynamicInput'
  import Result from 'src/views/Verifications/components/Result'
  import Verification from 'src/views/Verifications/components/Verification'
  import Wallet from 'src/views/Verifications/wallet/Wallet'
  
  import LogRocket from 'logrocket';
  import { Loading } from 'element-ui'
  
  export default {
    name: "view-share",
    components: {
      DynamicInput,
      Result,
      Verification,
      Wallet
    },
    props: {
      id: String
    },
    data () {
      return {
        error: false,
        notfound: false,
        resolved: false,
        resolvedResult: null,
        loadingResult: true,
        loadingVerification: true,
        verification: null,
        verifications: null,
        newVerification: null,
        rbName: null,
        rbTitle: null,
        valid: true
      }
    },
    mounted: function () {
      this.$store.commit('setPublicToken', this.id)
      
      this.loadingResult = true
      this.loadingVerification = true
      this.$api.getPubliShare(this.id)
        .then(response => {
          if(response.status == 204) {
            this.notfound = true
          } else {
            // this.build(response.data)
            this.verifications = response.data
            for(var i = 0; i < this.verifications.length; i++) {
              this.verifications[i].id = i
            }
          }
        })
        .catch(error => {
          console.log(error)
          this.error = true
        })
    },
    computed: {
      fullyLoaded () {
        return this.verification != null && this.newVerification != null && this.newVerification.institute != null
      },
      note () {
        return this.newVerification ? this.newVerification.note : null
      }
    },
    watch: {
      note (value) {
        if(value) {
          this.valid = true
        }
      }
    },
    methods: {
      build(verification) {
        this.verification = verification
        this.loadingResult = false
        this.$service.buildInstitute(this.verification.instituteId, this.verification)
          .then(response => {
            var builtVerification = this.$service.buildVerification(verification)
            builtVerification.institute = response
            this.newVerification = builtVerification
            this.loadingVerification = false
          })
          .catch(error => {
            console.log(error)
            this.loadingVerification = false
          })
      },
  }
}
</script>

<style>

</style>